import React from "react";
import portfolioData from "../data/portfolio.json";
import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";

const Projects = () => {
  const { projects } = portfolioData;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  return (
    <section id="projects" className="pt-20 w-full">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 text-center text-4xl font-light text-stone-800 dark:text-stone-200"
      >
        Projects
      </motion.h2>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto"
      >
        {projects.map((project) => (
          <motion.div key={project.id} variants={itemVariants} className="h-full">
            <Tilt
              tiltMaxAngleX={5}
              tiltMaxAngleY={5}
              scale={1.02}
              transitionSpeed={2500}
              className="h-full"
            >
              <div className="group relative overflow-hidden rounded-[2rem] w-full min-h-[400px] h-full mx-auto bg-white/60 dark:bg-stone-800/60 backdrop-blur-sm shadow-sm border border-stone-200/50 dark:border-stone-700/50 flex flex-col transition-shadow hover:shadow-xl">

                {/* Image Placeholder / Banner */}
                <div className="h-48 w-full bg-gradient-to-br from-stone-100 to-stone-200 dark:from-stone-700 dark:to-stone-800 relative overflow-hidden shrink-0">
                  {project.image ? (
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                    />
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center opacity-30">
                      <svg className="w-16 h-16 text-stone-400 group-hover:scale-110 transition-transform duration-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-8 flex flex-col flex-grow justify-between">
                  <div>
                    <h3 className="text-2xl font-medium tracking-tight mb-3 text-stone-800 dark:text-stone-100">
                      {project.title}
                    </h3>
                    <p className="text-stone-500 dark:text-stone-400 text-lg leading-relaxed mb-6 font-light">
                      {project.description}
                    </p>
                    <div className="mb-6">
                      <span className="text-xs font-semibold uppercase tracking-wider text-stone-400 block mb-2">Tech Stack</span>
                      <div className="text-stone-700 dark:text-stone-300 font-medium bg-stone-100 dark:bg-stone-700 inline-block px-3 py-1 rounded-lg text-sm">
                        {project.programming_languages}
                      </div>
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="flex gap-4 mt-auto">
                    {project.Github_url && (
                      <a
                        href={project.Github_url}
                        className="flex-1 text-center bg-transparent border border-stone-300 dark:border-stone-600 text-stone-700 dark:text-stone-300 px-4 py-3 rounded-xl hover:bg-stone-100 dark:hover:bg-stone-700 transition-colors font-medium text-sm"
                      >
                        Code
                      </a>
                    )}
                    {project.live_url && (
                      <a
                        href={project.live_url}
                        className="flex-1 text-center bg-stone-800 dark:bg-white text-white dark:text-stone-800 px-4 py-3 rounded-xl hover:bg-stone-700 dark:hover:bg-stone-100 transition-colors font-medium text-sm shadow-sm"
                      >
                        Live Demo
                      </a>
                    )}
                  </div>
                </div>

              </div>
            </Tilt>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Projects;